<template>
    <zen-one :showuserinfo="false" :crumbs="crumbs" title="Maklumat Pengguna">
        <!-- <z-page :title="" icon="fal fa-user"> -->
            <z-page title="User">
            


            <w-card bg-color="z-pale-blue" class="mt4">
                <w-flex justify-center align-center>
                     <div class="xs3">
                        <w-image
                            class="maa sh1 bdrsr d-block"
                            src="/images/avatar.png"
                            :width="100"
                            :height="100"
                        >
                        </w-image>
                    </div>
                    
                    <div class="xs12">
                        <w-flex class="mt3">
                            <div class="xs4">
                                <h5 class="fw-semibold m0">Nama :</h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ form.no_id }} | {{ form.name }}
                                </div>
                            </div>
                            
                            <div class="xs4">
                                <h5 class="fw-semibold m0">No. Telefon :</h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ form.phone_number }}
                                </div>
                            </div>
                              <div class="xs3">
                                <h5 class="fw-semibold m0">Emel :</h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ form.email }}
                                </div>
                            </div>
                          
                           
                        </w-flex>

                        <w-flex class="mt3 mb4">
                             <div class="xs4">
                                <h5 class="fw-semibold m0">Jawatan :</h5>
                                <div class="fw-normal my1 fs-1">
                                </div>
                            </div>
                            <div class="xs4">
                                <h5 class="fw-semibold m0">Tarikh Daftar :</h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ $zutil.dateformat(form.created_at) }}
                                </div>
                            </div>
                            <div class="xs4">
                                <h5 class="fw-semibold m0">
                                    Tarikh Kemas Kini :
                                </h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ $zutil.dateformat(form.updated_at) }}
                                </div>
                            </div>
                            
                        </w-flex>
                        <w-flex class="mt3 mb4">
                            <div class="xs4">
                                <h5 class="fw-semibold m0">Status :</h5>
                                <div class="fw-normal my1 fs-1">
                                    <template v-if="form.email_verified_at == null">
                                       Tidak Aktif
                                    </template>
                                    <template v-else>
                                         Aktif
                                    </template>
                                </div>
                            </div>
                            <div class="xs4">
                                <h5 class="fw-semibold m0">Jabatan :</h5>
                                <div class="fw-normal my1 fs-1">
                                </div>
                            </div>
                           
                        </w-flex>
                    </div>
                </w-flex>
                <template v-if="form.email_verified_at == null">
                    <w-flex class="mt3" wrap align-center justify-end>
                        <w-button class="my1" bg-color="primary" dark  @click="send()" >
                             <w-icon dark tile class="mr2">fal fa-save</w-icon> SAHKAN EMAIL
                        </w-button>
                    </w-flex>
                </template>
            <br>
            <w-tabs :items="tabs" :no-slider="false" active-class="primary">  
                    <template #item-content.1> 
                            
                    <w-flex justify-center align-center>
                      <div class="w-card__content content-hardcode">

                          <table class="table-dashboard" width="100%">
                              <thead>
                              <tr>
                                  <td >No</td>
                                  <td >Tindakan</td>
                                  <td >Pengguna</td>
                                  <td >Tarikh</td>
                                  <td>Catatan</td>
                              </tr>
                              </thead>
                              <tbody>
                              
                                  <tr v-for="dt, index in audit">
                                      <td class="w-table__cell text-left">
                                          {{(index + 1)}}
                                      </td>
                                      <td class="w-table__cell text-left">
                                          {{dt.tindakan_keterangan}}
                                      </td>
                                      <td class="w-table__cell text-left">
                                          {{ form.name }}
                                      </td>
                                      <td class="w-table__cell text-left">
                                          {{dt.tarikh}}
                                      </td>
                                      <td class="w-table__cell text-left">
                                          {{dt.catatan}}
                                      </td>
                                  </tr>
                                
                              </tbody>
                              
                          </table>
                        </div>
                      </w-flex>
                    <!-- </w-form> -->
                  </template>
            </w-tabs>
           
                    
            </w-card>
            
        </z-page>

        
    </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {


  
    resourceurl: this.service_ibayaq + 'user_profil',
    reload: true,
    audit: [],
      
      tabs: [
          { title: 'Jejak Audit', content: '' },
      ],
      crumbs: [
        // { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Utama', route: '/' },
        { label: 'Pentadbiran', route: '/admin/user' },
        { label: 'Pengguna', route: '/admin/user' }
      ],
    }
  },
    methods: {
        send(){

         // alert(status);
          // this.form.lkp_resit_status_id = status
        this.form.sahkan = 1
        this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                      .then(res => {
                        if (typeof this.onAfterEdit === "function") {
                            this.onAfterEdit()
                          }
                            this.$inertia.visit(this.$route('user_ibayar.index'))
                            this.janaJejakAudit();
                       
                      })
                      .catch(err => {

                      })
                      .finally(() => {
                          

                      });
        
        },

        getAudit()  {
          var app = this;

          if(this.id){
            if(this.id > 0){
              // this.$zcomm.get(this.ihasil +'terimaan_cek/'+this.id+''+window.location.search).then(res => {

            this.$zcomm.get(window.route('jejak_audit_ibayaq',this.id)).then(res => {
                this.audit = res;

              });
            }
          }
          
          
        },
        janaJejakAudit(){
            // this.$zcomm.update(this.ihasil + 'jejak_audit_ibayaq/'+this.form.id, this.form.id, this.form)
            // this.$zcomm.post(this.resourceurl + ".jejak_audit_ibayaq"  , this.form)
            this.$zcomm.update(window.route('simpan_jejak_audit_ibayaq',this.form))
                      .then(res => {

                        if (typeof this.onAfterEdit === "function") {
                            this.onAfterEdit()
                          }
                          this.$inertia.visit(this.$page.url, { preserveScroll: true })
                      })
                      .catch(err => {

                      })
                      .finally(() => {
                          

                      });
        
        },

 

  
    },
  watch: {

  },
  mounted() {

    this.getAudit();
    
      
  },
    
}
</script>